import React from 'react'

const Picker = () => {
  return (
    <>
      <div className='pick-color'>
    <div className='color-heading'>
      <h1>Color Picker</h1>
       <h2>W3Schools' famous color picker:</h2>
   </div>
   <div className='color-image'>
    <img src='https://www.w3schools.com/images/colorpicker.webp'></img>
   </div>
   </div>
    </>
  );
}

export default Picker;                    